import React from "react";
import "../css-coding/ContactSection.css";
import footerImage from "../assets/Profile.jpg";
import bgVideo from "../assets/footer-video.mp4"; // ✅ Imported video

const ContactSection = () => {
  return (
    <section className="contact-wrapper">
      {/* ✅ Background Video */}
      <video
        className="contact-bg-video"
        autoPlay
        loop
        muted
        playsInline
      >
        <source src={bgVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Left Form Card */}
      <div className="contact-form-card">
        <div className="contact-form-header">
          <span className="brand">Let’s Talk Lead Form Content</span>
          <h2>
            Have a project <span>in mind?</span>
          </h2>
        </div>
        <form className="contact-form">
          <label>Your name*</label>
          <input type="text" placeholder="Name" />
          <label>Mobile Number*</label>
          <input type="number" placeholder="+91 XXX55 XXX65" />
          <label>Service Needed*</label>
          <textarea placeholder="Your message" rows="4" />
          <button type="submit">Send Message</button>
          <p className="disclaimer">
            By submitting, you agree to our  Terms and{" "}
            Privacy Policy.
          </p>
          
        </form>
      </div>

     

      {/* Right Content */}
      <div className="contact-content">
        <h1>
          Let’s <span>talk.</span>
        </h1>
        <p className="intro">
          Tell us about your project whether it’s a Video Editing, Content Creation, or Social Media Marketing.
        </p>

        <div className="contact-highlights">
          <div>
            <strong>⚡ Quality Contents</strong>
            <p>
              Driven by creativity and consistency, we craft high-impact content that builds
community and elevates your brand.
            </p>
          </div>
          <div>
            <strong>✅ Timely Delivery</strong>
            <p>
              With consistency at our core, we ensure timely delivery while nurturing a
creative process that strengthens your community presence.
            </p>
          </div>
        </div>

        <div className="contact-person">
          <img src={footerImage} alt="Lauren Thompson" />
          <div>
            <p className="role">Team at The Growth Secret Media®</p>
            <h4>Prakash Raj</h4>
            <div className="button-container">
  <button onClick={() => window.location.href = "https://api.whatsapp.com/send/?phone=916382765055&text&type=phone_number&app_absent=0"}>
    Ask directly
  </button>
</div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
